import { DetailsImageResponse } from "../models/ResponseModels/DetailsImageResponse";
import { DetailSectionConfig } from "../Utilities";

export const detailsSections: DetailSectionConfig<DetailsImageResponse>[] = [
  {
    id: "general-section",
    title: "General",
    fields: [
      { id: "title", label: "Title:", key: "imageTitle" },
      { id: "description", label: "Description:", key: "description" },
      { id: "subject_person", label: "Person Shown:", key: "person" },
    ],
  },
  {
    id: "programme-section",
    title: "Programme",
    fields: [
      { id: "work_order_title", label: "Programme/Film Name:", key: "woTitle" },
      { id: "channel", label: "Channel:", key: "woChannel" },
      { id: "series_number", label: "Series number:", key: "seriesNumber" },
    ],
  },
  {
    id: "file-section",
    title: "File",
    fields: [
      { id: "type", label: "Element Type:", key: "imageType" },
      { id: "file-name", label: "File Name:", key: "fileName" },
      {
        id: "file-Size",
        label: "Size:",
        key: "fileSizeBytes",
        formatter: (v: number) => `${(v / 1024).toFixed(2)} KB `,
      },
      { id: "file_extension", label: "Extension:", key: "fileExtension" },
    ],
  },
  {
    id: "rights-section",
    title: "Usage Rights",
    fields: [
      { id: "copyright", label: "Copyright:", key: "copyright" },
      { id: "creator", label: "Creator:", key: "creator" },
    ],
  },
];
